export default "__VITE_ASSET__Ds_VhGqV__"